import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConfigSettings } from '@arc/arc-shared-frontend';
import { CreateWalletContextRequest } from '../models';

// Thin HTTP wrapper around session-service's wallet-context endpoint (BTPAY-7160).
// POST /v1/tenants/{tenantId}/paymentsessions/{sessionId}/walletcontext
@Injectable({
  providedIn: 'root',
})
export class WalletContextService {
  private readonly baseUrl: string;

  constructor(
    private httpClient: HttpClient,
    appConfig: AppConfigSettings,
  ) {
    this.baseUrl = appConfig.getconfig('sessionServiceUrl');
  }

  createWalletContext(
    tenantId: string,
    sessionId: string,
    request: CreateWalletContextRequest,
  ): Observable<void> {
    return this.httpClient.post<void>(
      `${this.baseUrl}/v1/tenants/${tenantId}/paymentsessions/${sessionId}/walletcontext`,
      request,
    );
  }
}
